"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginBase_1 = require("../PluginBase");
const ractive_1 = require("ractive");
/**
 * Ractive component plugin base plugin.
 *
 * @see https://ractive.js.org/v0.x/0.7/components
 */
class RactiveComponentPlugin extends PluginBase_1.default {
    /**
     * Gets the html element name for this component.
     *
     * @return {string}
     */
    getElementName() {
        return this.definition.getElementName();
    }
    /**
     * Gets component definition ids that should be appended to this component.
     *
     * This is required when one wants to render a component inside of
     * another component since ractive by default does not server all
     * for all.
     *
     * @return {string}
     */
    getDependentComponents() {
        return [];
    }
    /**
     * Gets the ractive component object.
     *
     * @return {Static<Ractive<Ractive>>}
     */
    getComponent() {
        return ractive_1.Ractive.extend({
            template: this.definition.getTemplate()
        });
    }
}
exports.default = RactiveComponentPlugin;
